<template>
  <q-dialog v-model="shown">
    <q-card style="width: 530px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Add Visit
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <iso-date-input
          v-model="user.newVisit"
          label="New Visit Date"
        />
        <q-inner-loading :showing="saving" />
      </q-card-section>
      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          v-show="!saving"
          class="col"
          label="Add Visit"
          color="primary"
          size="lg"
          :disable="!user.newVisit"
          @click="save"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import { IsoDate } from 'src/models/model'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'

export default {
  name: 'UserVisitsDialog',
  components: {
    IsoDateInput
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['close'],
  data () {
    return {
      shown: false,
      saving: false
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.$emit('close')
        this.user.resetField('newVisit')
      }
    }
  },
  methods: {
    async show () {
      this.user.newVisit = new IsoDate()
      this.shown = true
    },
    async save () {
      this.saving = true
      await this.user.addVisit()
      this.saving = false
      this.shown = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
